import { render, staticRenderFns } from "./float-zuji.vue?vue&type=template&id=0dc200d7&"
import script from "./float-zuji.vue?vue&type=script&lang=js&"
export * from "./float-zuji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports